import React from 'react';

const SurveysNavIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="2" width="8" height="4" rx="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <polyline points="9 12 11 14 15 10" />
        <line x1="9" y1="17" x2="15" y2="17" />
    </svg>
);

export default SurveysNavIcon;